import React, { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { authService } from "../../services";
import RouteConstants from "../../common/RouteConstants";

export default function Logout() {
  useEffect(() => {
    authService
      .logout()
      .then((signOuturl) => {
        if (
          sessionStorage.getItem("chk") &&
          sessionStorage.getItem("chk") == "aad"
        ) {
          window.location.assign(signOuturl.data);
        } else {
          window.location.assign("/login");
        }
      })
      .catch((err) => {
        console.log(err);
        sessionStorage.removeItem("accessToken");
        sessionStorage.removeItem("currentUser");
        //localStorage.clear();
        window.location.assign("/login");
      });
  }, []);

  return <></>;
}
